import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import CmsCreate from "./cmsCreate";
import CmsCreateHeader from "./cmsCreateHeader";
import { CmsMasterData } from "types/models/cmsMaster/CmsMasterApp";
const defaultCms: CmsMasterData = {
  PageID: BigInt(0),
  CategoryID: BigInt(0),
  IsLanding: false,
  Description1: "",
  Description2: "",
  Description3: "",
  Description4: "",
  IsActive: 1,
  IsHeader: 1,
  MetaTitle: "",
  MetaKeyword: "",
  MetaDesc: "",
  PageTitle: "",
  HeaderName1: "",
  HeaderName2: "",
  HeaderName3: "",
  HeaderName4: "",
  status: "Active",
};

const CmsCreateIndex: React.FC = () => {
  

  return (
    <>
     
        <AppAnimate animation="transition.slideUpIn" delay={200}>
          <AppCard>
            <CmsCreateHeader cms={defaultCms} />
           
            <AppGridContainer>
              <CmsCreate Cms={defaultCms} /> 
            </AppGridContainer>
          </AppCard>
        </AppAnimate>
      
      <AppInfoView />
    </>
  );
};

export default CmsCreateIndex;
